module.exports = __webpack_public_path__ + "static/media/jpeg.92ddffb0.svg";